import styled from 'styled-components';
import color from 'tinycolor2';
import { Button } from '@pearsontechnology/aero-components';

export const ScrollWrapper = styled.div`
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
  display: inline-flex;
  border-radius: 4px;
  box-shadow: ${(props) => props.theme['shadow.card']};
  background: ${(props) => props.theme['color.surface']};
  position: relative;
`;

export const Table = styled.table`
  border-collapse: collapse;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  padding-top: 40px;
`;

export const TableRow = styled.tr`
  position: relative;
`;

export const TableCell = styled.td`
  text-align: center;
  min-width: 163px;
  ${(props) => props.light ?
    `color: ${props.theme['color.text.light']};` :
    ''}
`;

export const TableHeaderCell = styled.th`
  position: sticky;
  top: 0;
  left: 0;
  text-align: center;
  min-width: ${(props) => props.topLeftHeader ? '200px' : '163px'};
  background: ${(props) => props.theme['color.surface']};
  font-weight: 400;
  box-sizing: content-box;
`;

export const TableHeaderCellScrollButton = styled.th`
  position: sticky;
  top: 0;
  ${(props) => props.left && 'left: 232px;'}
  ${(props) => props.right && 'right: 0;'}
  width: 26px;
  height: 100%;
  background: ${(props) => props.theme['color.surface']};
`;

export const ScrollButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 100%;
  min-height: 106px; // Firefox...
`;

export const TableHeaderCellStudentColumn = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  vertical-align: middle;
`;

export const TableHeaderCellScoreColumn = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: 20%;
  vertical-align: middle;
`;

export const TableHeaderCellWalkableColumn = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;

export const Subheading = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme['color.text.light']};
`;

export const TableHeaderCellSecondLine = styled.div`
  margin-top: 18px;
`;

export const TableHead = styled.thead`
  ${TableHeaderCell} {
    z-index: 16;
    padding: 16px 10px 9px 10px;
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme['color.border']};
  }

  ${TableHeaderCellScrollButton} {
    z-index: 32;
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme['color.border']};
  }

  ${TableHeaderCell}:first-child {
    z-index: 32;
    padding: 16px 16px 9px 16px;

    &::after {
      content: '';
      border-right: 1px solid ${(props) => props.theme['color.border']};
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
`;

export const TableBody = styled.tbody`
  ${TableRow} {
    border-top: 1px solid ${(props) => color(props.theme['color.border']).setAlpha(color(props.theme['color.border']).getAlpha() * 0.5).toString()};
  }

  ${TableRow}:first-child {
    border: 0;
  }

  ${TableHeaderCell} {
    padding: 8px 16px;
    box-shadow: inset -1px 0 0 0 ${(props) => props.theme['color.border']};
  }
`;
